export default function ErrorBanner({ message, children }) {
  const text = String(message || '').trim()
  if (!text && !children) return null
  return (
    <div style={{
      background: '#fdecea', color: '#611a15', border: '1px solid #f5c2c0',
      padding: '8px 10px', borderRadius: 6, margin: '8px 0',
    }}>
      {text || children}
    </div>
  )
}

